import { apiRequest } from "../api.jsx";

export const getCart = () => apiRequest("/cart");
export const addCartItem = (productId, quantity, variantId = "", colorId = "") =>
  apiRequest("/cart/add", "POST", { productId, quantity, variantId, colorId });
export const updateCartItem = (productId, quantity, variantId = "", colorId = "") =>
  apiRequest("/cart/update", "PUT", { productId, quantity, variantId, colorId });
export const removeCartItem = (productId, variantId = "", colorId = "") =>
  apiRequest(
    `/cart/remove/${productId}?variantId=${encodeURIComponent(variantId)}&colorId=${encodeURIComponent(colorId)}`,
    "DELETE",
    { variantId, colorId },
  );
export const clearServerCart = () => apiRequest("/cart/clear", "DELETE");
